/*
   Bones Scripts File
Author: Eddie Machado

This file should contain any js scripts you want to add to the site.
Instead of calling it in the header or throwing it inside wp_head()
this file will be called automatically in the footer so as not to
slow the page load.

*/

// IE8 ployfill for GetComputed Style (for Responsive Script below)
if (!window.getComputedStyle) {
  window.getComputedStyle = function (el, pseudo) {
    this.el = el;
    this.getPropertyValue = function (prop) {
      const re = /(\-([a-z]){1})/g;
      if (prop == 'float') prop = 'styleFloat';
      if (re.test(prop)) {
        prop = prop.replace(re, function () {
          return arguments[2].toUpperCase();
        });
      }
      return el.currentStyle[prop] ? el.currentStyle[prop] : null;
    };
    return this;
  };
}

// as the page loads, call these scripts
jQuery(document).ready(($) => {
  // Elements to which we want to attach comment functionality
  const elems = ['h1', 'h2', 'h3', 'h4', 'li', 'p'];

  // Attach comment functionality to all elements
  elems.forEach((e) => {
    // Add span wrappers with unique IDs to all elements
    // and attach comment count indicators to elements
    $(`.ohjelmatyo .entry-content ${e}`).each(function (i) {
      const id = `${e}-${i + 1}`;
      const comments = $('.ohjelmatyo #rightcolumn').find(
        `[data-parent-element='${id}']`
      );
      let count = comments.length;

      const wrap = $(this).wrap(`<span class="wrap" id="${id}"></div>`);

      if (count > 0) {
        // Also count replies to original comments
        comments.each(function () {
          const commentId = $(this).find('article').attr('id');
          const subComments = $('.ohjelmatyo #rightcolumn').find(
            `[data-parent-element='${commentId}']`
          );
          count += subComments.length;
        });

        $(this).parent().append(`<a class="badge">${count}</a>`);
      }
    });
  });

  function bindOnMouseDown(event) {
    const isPasswordProtectedPage = $(this)
      .children()
      .children('input[name=post_password]');
    if (isPasswordProtectedPage.length === 0) {
      const target = $(event.target).attr('class');
      const id = $(this).parent('.wrap').attr('id');
      console.log(target);
      console.log(id);
      $('#comment_target').html($(this).remove('.badge').html());
      $('#element_id').val(id);
      $('#commentModal').modal('show');
    }
  }

  function bindOnMouseDownComment(event) {
    const id = $(this).parents('article').attr('id');
    $('#comment_target').html(
      $(this).parents('article').first().find('.comment_content').html()
    );
    $('#element_id').val(id);
    $('#commentModal').modal('show');
  }

  function hideComments(event) {
    $(
      '.ohjelmatyo #rightcolumn .comment, .ohjelmatyo #rightcolumn .comment-hide'
    ).hide();
  }

  function filterComments(event) {
    // Fetch main level comments
    const parentElement = $(event.target).parent();
    const sidebar = $('.ohjelmatyo #rightcolumn');
    const id = parentElement.attr('id');
    const mainCommentsToShow = sidebar.find(`[data-parent-element="${id}"]`);

    // Add move comments element below selected element and hide them all
    sidebar.detach().appendTo(parentElement);
    sidebar.find('.comment').hide();

    // Fetch sublevel comments and attach to first level comment
    mainCommentsToShow.each(function () {
      const mainCommentId = $(this).find('article').attr('id');
      const secondaryComments = sidebar.find(
        `[data-parent-element="${mainCommentId}"]`
      );
      secondaryComments.detach().appendTo(this);
      secondaryComments.fadeIn(1000);
    });

    // Reveal comments relating to selected element
    mainCommentsToShow.fadeIn(1000);
    $('.ohjelmatyo #rightcolumn .comment-hide').fadeIn(1000);
  }

  // Clear comment box on modal close
  $('[data-dismiss=modal]').click(() => {
    $('#commentModal textarea').val('');
  });

  const sidebarCopy = $('.ohjelmatyo #rightcolumn').clone();

  $('.showall').one('click', showAll);

  function showAll() {
    $(this).hide();

    $(
      '.ohjelmatyo .entry-content p, .ohjelmatyo .entry-content li, .ohjelmatyo .entry-content h1, .ohjelmatyo .entry-content h2, .ohjelmatyo .entry-content h3, .ohjelmatyo .entry-content h4'
    ).each(function (i) {
      const parent = $(this).parent();

      const comments = sidebarCopy.find(
        `[data-parent-element="${$(this).parent().attr('id')}"]`
      );

      $('<div class="comment-wrapper comment-wrapper-js"></div>')
        .appendTo(parent)
        .html(comments);

      $('.badge').hide();

      $('.btn-print').show();
    });
  }

  $('.ohjelmatyo .entry-content .badge').bind('click touch', filterComments);
  $('.ohjelmatyo .comment-hide').bind('click touch', hideComments);

  $('.ohjelmatyo .entry-content p').bind('click touch', bindOnMouseDown);
  $('.ohjelmatyo .entry-content li').bind('click touch', bindOnMouseDown);
  $('.ohjelmatyo .entry-content h1').bind('click touch', bindOnMouseDown);
  $('.ohjelmatyo .entry-content h2').bind('click touch', bindOnMouseDown);
  $('.ohjelmatyo .entry-content h3').bind('click touch', bindOnMouseDown);
  $('.ohjelmatyo .entry-content h4').bind('click touch', bindOnMouseDown);

  $('.ohjelmatyo .comment_reply').bind('click touch', bindOnMouseDownComment);

  $('.toggle').click(function () {
    const checkBoxes = $(this).parent().find('.toggle-checkbox');
    checkBoxes.prop('checked', !checkBoxes.prop('checked'));
  });

  /*
		 Responsive jQuery is a tricky thing.
		 There's a bunch of different ways to handle
		 it, so be sure to research and find the one
		 that works for you best.
		 */

  /* getting viewport width */
  const responsive_viewport = $(window).width();

  /* if is below 481px */
  if (responsive_viewport < 481) {
  } /* end smallest screen */

  /* if is larger than 481px */
  if (responsive_viewport > 481) {
  } /* end larger than 481px */

  /* if is above or equal to 768px */
  if (responsive_viewport >= 768) {
    /* load gravatars */
    $('.comment img[data-gravatar]').each(function () {
      $(this).attr('src', $(this).attr('data-gravatar'));
    });
  }

  /* off the bat large screen actions */
  if (responsive_viewport > 1030) {
  }

  // add all your scripts here

  /* Looks for rel=popover and rel=tooltip for Bootstrap JS */
  jQuery('a[rel=popover]')
    .popover()
    .click((e) => {
      e.preventDefault();
    });

  jQuery('a[rel=tooltip]').tooltip();
}); /* end of as page load scripts */

/*! A fix for the iOS orientationchange zoom bug.
	Script by @scottjehl, rebound by @wilto.
	MIT License.
	*/
(function (w) {
  // This fix addresses an iOS bug, so return early if the UA claims it's something else.
  if (
    !(
      /iPhone|iPad|iPod/.test(navigator.platform) &&
      navigator.userAgent.indexOf('AppleWebKit') > -1
    )
  ) {
    return;
  }
  const doc = (w && w.document) || document;
  if (!doc.querySelector) {
    return;
  }
  const meta = doc.querySelector('meta[name=viewport]');
  const initialContent = meta && meta.getAttribute('content');
  const disabledZoom = `${initialContent},maximum-scale=1`;
  const enabledZoom = `${initialContent},maximum-scale=10`;
  let enabled = true;
  let x;
  let y;
  let z;
  let aig;
  if (!meta) {
    return;
  }
  function restoreZoom() {
    meta.setAttribute('content', enabledZoom);
    enabled = true;
  }
  function disableZoom() {
    meta.setAttribute('content', disabledZoom);
    enabled = false;
  }
  function checkTilt(e) {
    aig = e.accelerationIncludingGravity;
    x = Math.abs(aig.x);
    y = Math.abs(aig.y);
    z = Math.abs(aig.z);
    // If portrait orientation and in one of the danger zones
    if (
      !w.orientation &&
      (x > 7 || (((z > 6 && y < 8) || (z < 8 && y > 6)) && x > 5))
    ) {
      if (enabled) {
        disableZoom();
      }
    } else if (!enabled) {
      restoreZoom();
    }
  }
  w.addEventListener('orientationchange', restoreZoom, false);
  w.addEventListener('devicemotion', checkTilt, false);
})(this);
